/**
 * Scadenze compliance ANNUALI FISSE (Specifica). Lista statica, facilmente
 * modificabile: NON inventare altre date. `mese`/`giorno` sono ricorrenti ogni anno;
 * il giorno è indicativo dove la norma indica un mese (es. MUD a luglio).
 */
export interface ScadenzaCompliance {
  chiave: string;
  label: string;  // acronimo normativo (nome proprio, non tradotto)
  mese: number;   // 1-12
  giorno: number; // 1-31 (indicativo)
  nota?: string;  // CHIAVE i18n (tradotta al render)
}

export const SCADENZE_COMPLIANCE: ScadenzaCompliance[] = [
  { chiave: 'rentri', label: 'RENTRI', mese: 4, giorno: 30 },
  { chiave: 'cdc_raee', label: 'CdC RAEE', mese: 4, giorno: 30 },
  { chiave: 'mud', label: 'MUD', mese: 7, giorno: 1, nota: 'dashboard.scadenze.mud_nota' },
];

/** Prossima occorrenza (da oggi) della scadenza, come Date. */
export function prossimaOccorrenza(s: ScadenzaCompliance, oggi = new Date()): Date {
  const annoCorrente = oggi.getFullYear();
  let d = new Date(annoCorrente, s.mese - 1, s.giorno);
  if (d < new Date(oggi.getFullYear(), oggi.getMonth(), oggi.getDate())) {
    d = new Date(annoCorrente + 1, s.mese - 1, s.giorno);
  }
  return d;
}
